import React, { useState } from 'react'
import {  Button, Modal } from "react-bootstrap";

const RemarkModal = ({ remarkshowModal, 
    setRemarkshowModal ,
    setshowremarkCard,
    insituteVerifyList,
    setInsituteVerifyList,
    setRemarkdata,
    setVerficationList,remarkdata,currentRemarkId,updateRemark,
        onClose,
}) => {
    const [error, setError] = useState("");
     // Handle input change with validation (Only character count)
     const handleInputChange = (e) => {
        const inputText = e.target.value;
        const charCount = inputText.length;

        if (charCount > 50) {
            setError("Character limit exceeded! (Max 150 characters)");
        } else {
            setError(""); // Clear error if within limit
        }

        // Allow input only if within character limit
        if (charCount <= 50) {
            setRemarkdata(inputText);
        }
    };
    const handleRemarkSubmit = () => {
        if (remarkdata.trim() === "") {
            setError("Please write the remark.");
            return;
        }
        if (remarkdata.length > 50) {
            setError("Please ensure the remark is within 50 characters.");
            return;
        }
       
        insituteVerifyList.map((data) => {
              if (currentRemarkId === data.id) {
                data.isError = true;
              }
            });
        updateRemark(remarkdata);
        setRemarkshowModal(false);
        setshowremarkCard(false)
        setRemarkdata('');
        setError(""); // Clear error on successful submission
    };
    const handleClose = () => {
      
        setError(""); // Clear error message
        setRemarkdata(""); // Reset input field
        setRemarkshowModal(false); // Close modal
    };
   
    return (
        <>
            <Modal className="fade" show={remarkshowModal}>
                <Modal.Header>
                    <Modal.Title> Remarks</Modal.Title>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={handleClose}
                    >

                    </Button>
                </Modal.Header>
                <Modal.Body>
                <span>Only 50 characters allowed <span style={{color: 'red'}}>*</span></span>
                    <div className="mb-3 pt-3">
                        <textarea
                            name="write-email"
                            id="write-email"
                            cols="30"
                            rows="5"
                            className="form-control"
                            placeholder="It's really an amazing.I want to know more about it..!"
                            value={remarkdata}
                            onChange={handleInputChange}
                        ></textarea>
                         {error && <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>{error}</p>}
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <button
                    
                    onClick={handleRemarkSubmit} 
                        className="btn btn-warning btn sweet-confirm"
                        disabled={remarkdata.trim() === ""}
                    >
                       Remarks
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RemarkModal
